export default {"src":"/_next/static/media/radio-checked.78fc42e0.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};